module.exports = __webpack_public_path__ + "static/SDG-30825e07823d2344ca39e28e49736c67.png";